import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import ReturnIcon from '@material-ui/icons/ArrowBack';
import ImportIcon from '@material-ui/icons/Unarchive';
import ExportIcon from '@material-ui/icons/Archive';
import SGEIcon from '@material-ui/icons/CompareArrows';
import ExcelAPI from '../../../../API/ExcelAPI';
import Dialog from '@material-ui/core/Dialog';
import ConfirmationDialog from '../../../Utils/ConfirmationDialog';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { handleServerError, handleSpecialCharacters } from '../../../../Utils/Helper';
import { FP_GROUP } from '../../../../Utils/Constants';
import NOLSSyncAPI from '../../../../API/NOLSSyncAPI';


const styles = theme => ({
  titleHead: {
    backgroundColor: '#F6F6F6',
    flex: '0 0 auto'
  },
  secondToolBar: {
    paddingLeft: '12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '52px'
  },
  searchArea: {
    display: 'flex',
    alignItems: 'inherit'
  },
  formControl: {
    margin: '6px',
    minWidth: '150px'
  },
  textField: {
    width: '240px'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  }
});


class TransportsToolbarEdit extends React.Component {
  excelAPI;

  constructor(props) {
    super(props)
    this.state = {
      searchBy: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      loading: false,
      success: false,
      openError: false,
      alertMessage: '',
      openDialog: false,
      fileName: ''
    }
    this.excelAPI = new ExcelAPI();
  }

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleSearch = event => {
    this.setState({ searchBy: handleSpecialCharacters(event.target.value) });
    this.props.reloadTableBySearch(handleSpecialCharacters(event.target.value));
  };

  handleClickGoBack() {
    this.props.handleChangeShowContent('transportsByLot');
  };

  handleClickCarsByLotToSGE = () => {
    this.setState({
      openDialog: true,
      confirmationQuestion: 'Tem a certeza que pretende ATUALIZAR o SGE?',
      confirmationMessage: 'A informação relativamente às viaturas do lote será guardada.',
      confirmationFunction: this.handleSubmitSaveCarOnSGE,
      cancelFunction: this.handleCloseDialog
    });
  }

  handleSubmitSaveCarOnSGE = () => {
    const nolsSyncAPI = new NOLSSyncAPI();
    nolsSyncAPI.sendUpdateOrderByLot(this.props.negotiationLotId).then(() => {
      this.setState({
        loading: false,
        success: true
      });
      setTimeout(() => {
        this.setState({
          success: false
        });
        this.handleCloseDialog();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog();
    });
  };

  handleClickExport = () => {
    this.excelAPI.getExcelTransportCarsListByLot(this.props.negotiationLotId).then(response => {
      this.setState({
        urlDownload: response.request.responseURL
      });
    }).catch((error) => {
      this.setState({
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleClickSubmitFile = () => {
    this.setState({ loading: true });
    var formData = new FormData();
    var excelfile = document.querySelector('#file');
    formData.append('excel_carros', excelfile.files[0]);
    this.excelAPI.postExcelTransportCarsListByLot(formData, this.props.negotiationLotId).then(() => {
      this.setState({
        loading: false,
        success: true,
        openSuccess: true,
        alertMessage: 'Ficheiro submetido com sucesso!',
        fileName: ''
      });
      setTimeout(() => {
        this.setState({
          openSuccess: false,
          autoHideDuration: 3000
        })
      }, 3000);
      this.handleCloseDialog()
      this.props.reloadTableEdit()
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleCloseDialog();
      this.props.reloadTableEdit();
    });
  };

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  handleClickImportExcel = () => {
    document.querySelector('#file').click();
  };

  handleChange = name => event => {
    const sFileName = event.target.value;
    this.setState({ [name]: event.target.value });
    this.setState({
      openDialog: true,
      fileName: sFileName,
      confirmationQuestion: 'Tem a certeza que pretende submeter o ficheiro ' + sFileName + '?',
      confirmationMessage: 'Os valores serão registados ou, em caso de alteração de valores já existentes, sobrepostos a esses mesmos.',
      confirmationFunction: this.handleClickSubmitFile,
      cancelFunction: this.handleCloseDialog
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.secondToolBar}>

        <iframe title='openExcel' style={{ display: 'none' }} src={this.state.urlDownload}></iframe>
        <input style={{ display: 'none' }} type='file' id='file' name='file' accept='.xls, .xlsx' onChange={this.handleChange('path')} />

        <Typography className={classes.titleHead} variant='title' id='transportsTitle'>
          VIATURAS COM GESTÃO DE TRANSPORTE - COMPRAS FIRMES
        </Typography>

        <div className={classes.searchArea}>
          <FormControl className={classes.formControl}>
            <Grid container spacing={8} alignItems='flex-end'>
              <Grid item>
                <SearchIcon height='24px' />
              </Grid>
              <Grid item>
                <TextField
                  id='search'
                  label='Pesquisar'
                  type='search'
                  className={classes.textField}
                  value={this.state.searchBy}
                  onChange={this.handleSearch}
                />
              </Grid>
            </Grid>
          </FormControl>
          <Tooltip title='Retroceder' placement='bottom' >
            <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => this.handleClickGoBack()} >
              <ReturnIcon />
            </Button>
          </Tooltip>
          <Tooltip title='Ligação ao NOLS' placement='bottom' >
            <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={() => { this.handleClickCarsByLotToSGE() }}
              disabled={this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}>
              <SGEIcon />
            </Button>
          </Tooltip>
          <Tooltip title='Receber Excel' placement='bottom' >
            <Button type='file' variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickImportExcel}
              disabled={this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}>
              <ImportIcon />
            </Button>
          </Tooltip>
          <Tooltip title='Enviar Excel' placement='bottom' >
            <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClickExport}
              disabled={this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}>
              <ExportIcon />
            </Button>
          </Tooltip>

          <Dialog
            open={this.state.openDialog}
            onClose={this.handleCloseDialog}
          >
            <ConfirmationDialog
              openConfirmationDialog={this.state.openDialog}
              handleClose={this.handleCloseDialog.bind(this)}
              confirmationQuestion={this.state.confirmationQuestion}
              confirmationMessage={this.state.confirmationMessage}
              confirmationFunction={this.state.confirmationFunction.bind(this)}
              cancelFunction={this.state.cancelFunction.bind(this)}
              loading={this.state.loading}
              success={this.state.success}
            />
          </Dialog>

          <SnackbarAlert autoHideDuration={this.state.autoHideDuration} openSuccess={this.state.openSuccess} openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

        </div>

      </div>
    );
  }
};

TransportsToolbarEdit.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(TransportsToolbarEdit));


// WEBPACK FOOTER //
// ./src/components/Transports/ByLot/Edit/TransportsToolbarEdit.js